import { XdrLiveSearchQueryPanelWebComponent } from './component/XdrLiveSearchQueryPanelWebComponent';
import { WEB_COMPONENT_XDR_LIVE_SEARCH_QUERY_PANEL } from '../../webcomponents.constants';

export { XdrLiveSearchQueryPanelWebComponent };

window.customElements.define(WEB_COMPONENT_XDR_LIVE_SEARCH_QUERY_PANEL, XdrLiveSearchQueryPanelWebComponent);
